import { Parser } from '~/api';
import RequestService from './request';

interface GetModpackVersionsRequest {
    platform: string;
    modpackId: string;
}

interface InstallModpackRequest {
    platform: string;
    modpack_id: string;
    version_id: string;
    format: boolean;
}

interface ReindexModpackRequest {
    platform: string;
    modpack_id: string;
}

class ModpacksService {
    get(req: PaginatableRequest): Promise<ListResponse> {
        return RequestService.get('/servers/:server/modpacks', req).then(Parser.parse);
    }

    getVersions(req: GetModpackVersionsRequest): Promise<ListResponse> {
        return RequestService.get(`/servers/:server/modpacks/${req.platform}/${req.modpackId}`).then(Parser.parse);
    }

    install(data: InstallModpackRequest) {
        return RequestService.post('/servers/:server/modpacks', data, {
            timeout: 60000,
        });
    }

    reindex(data: ReindexModpackRequest) {
        return RequestService.post('/servers/:server/modpacks/reindex', data).then(Parser.parse);
    }
}

export default new ModpacksService();
